import * as React from 'react';
import {ProductContext} from '../../../../pages/ProductStencil';
import {useContext} from "react";
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {isLoggedIn} from "../../../../../data/user.model";
import { Obsolete } from '../Obsolete/Obsolete';
import StockDot from "../../common/StockDot";

export const DetailsDescription = () => {
    const {product, SapDetails, activeProductIndex, Packaging} = useContext(ProductContext);
    const translate = useI18N();

    if(SapDetails[0]?.IsObsolete && isLoggedIn()) {
        return <Obsolete />;
    }

    const {
        title,
    } = product;

    const DisplayPackaging = (SapDetails[activeProductIndex]?.Packaging && SapDetails[activeProductIndex]?.Packaging.trim() !== '0') ? SapDetails[activeProductIndex]?.Packaging : '';

    return (
        <>
            <h1 className="pdp__overview--title">
                {title}
                <div className='pdp__overview--subtitle'>{DisplayPackaging} <StockDot stockType={Packaging[activeProductIndex]?.StockType}/></div>
            </h1>
            <a className="pdp__overview--link" href={"#product-details"}>{translate("View product details")}</a>
        </>
    );
};
